<template>
  <div class="row" style="min-height: 74vh">
    <div class="col-1"></div>
    <div class="col-10 mt-4">
      <div>
        <div class="card col-12 mb-3 mt-3">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-12 pe-1 mt-1">
              <div class="card-body text-start">
                <span class="card-title fw-bold" style="font-size: 1rem">
                  <i class="icon-users" /> HR Personel Passport
                </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12">
              <div class="card-body text-end">
                <button class="col-12 btn btn-outline-default" id="passport-table" @click="exportTableToExcel()">
                  <span class="mx-1">Export Excel</span>
                </button>
              </div>
            </div>
            
          </div>
        </div>
        <div class="col-md-12" v-permcheck="'Hr_PersonelManagement.Hr_PersonelManagement.R'">
          <div>
            <div class="">
              <div class="pt-2">
                <div class="card col-12 mb-1">
                  <div class="row">
                    <div class="col-10">
                      <div class="m-2 col-md-8 col-sm-12 d-flex">
                        <div class="input-group pe-3">
                          <input class="form-control" required maxlength="50" placeholder="Search" v-model="search" />
                        </div>
                        <div class="input-group pe-3">
                          <input class="form-control" required maxlength="3" placeholder="Search By TLC"
                            v-model="searchTLC" />
                        </div>
                      </div>
                    </div>
                    <div class="col-2 align-self-center text-end pe-1">
                      <div class="icon-info me-2 text-warning tooltip">
                        <div class="bottom">
                          <h5>Passaport Document Stats</h5>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #8cc3a9"></div>
                            <p class="col-10">
                              Last 14 months before expiry date
                            </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ffe083"></div>
                            <p class="col-10">14 months before expiry date</p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ffe083"></div>
                            <p class="col-10">12 months before expiry date</p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ed9aa2"></div>
                            <p class="col-10">11 months before expiry date</p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #454545"></div>
                            <p class="col-10">Expired</p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #d3d3d3"></div>
                            <p class="col-10">No Passport</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="card tableFixHead" style="max-height: 530px">
                  <table class="table table-striped align-middle" style="
                      table-layout: auto;
                      overflow-x: auto;
                      overflow-y: auto;
                    ">
                    <thead>
                      <tr>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          "></th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Employee Id
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Company
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Name
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Surname
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Gender
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          TLC
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          EMail
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Passport No
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Date of Issue
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Country of Issue
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Nationality
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          Date of Expiry
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          STAT
                        </th>
                        <th style="
                            background-color: rgb(86, 117, 156);
                            color: white;
                          ">
                          DOC
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="personelList != []">
                      <tr v-for="(row, index) in filteredData" :key="index">
                        <td style="color: #454543">
                          <div class="status col-2 me-2 mt-1" :style="{
                            backgroundColor: determineColorByStat(row.STAT),
                          }"></div>
                        </td>
                        <td style="color: #454543">
                          {{ row.NefaEmployeeId }}
                        </td>
                        <td style="color: #454543">
                          {{ row.Workplace }}
                        </td>
                        <td style="color: #454543">
                          {{ row.FirstName }}
                        </td>
                        <td style="color: #454543">
                          {{ row.LastName }}
                        </td>
                        <td style="color: #454543">
                          {{ row.Gender }}
                        </td>
                        <td style="color: #454543">
                          {{ row.TLC }}
                        </td>
                        <td style="color: #454543">
                          {{ row.Email }}
                        </td>
                        <td style="color: #454543">
                          {{
                            row.DocumentNumber.length
                            ? row.DocumentNumber
                            : "-"
                          }}
                        </td>
                        <td style="color: #454543">
                          {{
                            row.DateOfIssue
                            ? new Date(row.DateOfIssue).toLocaleDateString()
                            : "-"
                          }}
                        </td>
                        <td style="color: #454543">
                          {{
                            row.CountryOfIssue.length
                            ? row.CountryOfIssue
                            : "-"
                          }}
                        </td>
                        <td style="color: #454543">
                          {{
                            row.NationalityCode.length
                            ? row.NationalityCode
                            : "-"
                          }}
                        </td>
                        <td style="color: #454543">
                          {{
                            row.DateOfExpiry
                            ? new Date(row.DateOfExpiry).toLocaleDateString()
                            : "-"
                          }}
                        </td>
                        <td style="color: #454543">
                          {{ row.STAT }}
                        </td>
                        <td style="color: #454543">
                          <button class="col-12 btn btn-outline-default d-flex justify-content-center"
                            data-bs-toggle="modal" data-bs-target="#showModal" :disabled="!row.DocumentExtension.length"
                            @click="showImgBtn(row)">
                            <i class="icon-image me-1" style="padding-top: 3px" />
                            <span class="mx-1">Show</span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!filteredData.length">
                      <tr>
                        <td :colspan="15" style="color: #454543">
                          <a style="color: #454543">
                            <span class="card-title fw-bold">No Data</span>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="showModal" tabindex="-1" aria-labelledby="showModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" id="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                @click="closeModal()"></button>
            </div>
            <div class="modal-body">
              <div v-if="fileExtension !== ''">
                <div v-if="this.fileExtension === 'pdf'">
                  <embed style="height: 800px" type="application/pdf" :src="globalPdfUrl" width="100%" height="100%"
                    alt="pdf" background-color="0xFF525659" top-toolbar-height="56" full-frame="" internalinstanceid="21"
                    title="CHROME" />
                </div>
                <div v-else>
                  <img :src="globalImgUrl" style="
                      width: -webkit-fill-available;
                      height: 400px;
                      object-fit: contain;
                    " />
                </div>
              </div>
              <div v-else class="shadow p-3 mb-5 bg-body rounded" style="border: 1px solid red">
                <p class="p-3 text-center" style="color: #b7323e">
                  No Documents
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.status {
  width: 15px;
  height: 15px;
}

.nav-pills .nav-link.active {
  background-color: rgb(86, 117, 156);
}

input {
  font-size: 14px;
}

.table {
  --bs-table-striped-bg: rgb(86, 117, 156, 0.1);
  margin-bottom: 0;
}

.row {
  --bs-gutter-x: 0 !important;
}

.btn-outline-default {
  --bs-btn-color: rgb(86, 117, 156);
  --bs-btn-border-color: rgb(86, 117, 156);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(86, 117, 156);
  --bs-btn-hover-border-color: rgb(86, 117, 156);
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86, 117, 156);
  --bs-btn-active-border-color: rgb(86, 117, 156);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(86, 117, 156);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(86, 117, 156);
  --bs-gradient: none;
}

a {
  color: rgb(86, 117, 156);
}

.tableFixHead {
  overflow: auto;
}

.tableFixHead thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.tooltip {
  display: contents;
  color: black;
  position: relative;
  border-bottom: 1px dotted #666;
  text-align: left;
}

.tooltip .bottom {
  min-width: 250px;
  top: 50px;
  left: 98%;
  transform: translate(-49%, 0);
  padding: 10px 20px;
  color: #444444;
  background-color: #eef1f5;
  font-weight: normal;
  font-size: 13px;
  border-radius: 8px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  display: none;
}

.tooltip:hover .bottom {
  display: block;
}

.tooltip .bottom i {
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 12px;
  overflow: hidden;
}

.tooltip .bottom i::after {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  left: 50%;
  transform: translate(-50%, 50%) rotate(45deg);
  background-color: #eeeeee;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

h5 {
  font-size: 0.9rem;
  font-weight: bold;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import { mapActions } from "vuex";
import { API } from "@/utils/mixins.js";
import Vue from "vue";
import * as XLSX from "xlsx";

import "vue2-datepicker/index.css";

Vue.use(require("vue-moment"));

import { createUrl } from "@/http";

export default {
  mixins: [API],
  components: {},
  data() {
    return {
      selectedValue: "Select",
      isActiveSubTable: false,
      opened: [],
      selectedIndex: -1,
      visible: false,
      globalImgUrl: "",
      globalPdfUrl: "",
      tabIndex: 0,
      btnCreateLabel: "",
      multiSelectValue: [],
      multiSelectOptions: [],
      nationalityOptions: [],
      nationalityOptionsValue: "",
      personelList: [],
      imageUrl: "",
      personelListByID: [],
      isDeleted: false,
      isShow: false,
      isCreated: true,
      isCreatedBtn: false,
      search: "",
      searchTLC: "",
      userSearch: "",
      DistSearch: "",
      user: [],
      headers: ["Name", "Surname", "Gender", "TLC", "Email", "Rank"],
      file: "",
      file2: "",
      file3: "",
      file4: "",
      isActiveClass: "",
      getImageUrl: createUrl("HR/personel/ShowImageVer2"),
      getPdfUrl: createUrl("HR/personel/ShowPdfVer2"),
      fileExtension: "",
      personInformation: [],
      medicalCheckInformation: [],
      licenceInformation: [],
      visaInformation: [],
      passportInformation: [],
      landingInformation: [],
      indeksNo: [],
      selectedIndexFileExtension: [],
      DocPID: "",
      indeks: "",
      tooltipVisible: false,
      usersWithPerms: [],
      distinctedPositions: [],
      permissionID: -1,
      permFullName: "",
      userPermsList: [],
      permissionShortCode: "",
      isToggleActived: [],
      iconList: [
        {
          type: true,
          icon: "icon-plus",
        },
        {
          type: false,
          icon: "icon-minus",
        },
      ],

      genders: [
        {
          gender: "Male",
          value: "M",
        },
        {
          gender: "Female",
          value: "F",
        },
      ],

      documentForm: {
        id: "",
        documentTypeID: "",
        documentTypeIndex: "",
        Document_P_ID: "",
        documentIndeksNo: "",
      },
      personCheckInputForm: {
        Id: "",
        file: {},
        file2: {},
        file3: {},
        file4: {},
        name: "",
        surname: "",
        tlc: "",
        description: "",
        mail: "",
        birtdate: "",
        gender: "",
        documentType: "",
        identity: "",
        baseCountry: "",
        rank: -1,
        Nefa_Employee_Id: "",
        CompanyCode: "",
        company: "",
      },
      medicalCheckInputForm: {
        id: "",
        dateOfIssue: "",
        dateOfExpiry: "",
        type: "",
        multiselectType: "",
        CVL_DESCRIPTION: "",
        LICENCE_TYPE: "",
        LICENCE_NO: "",
        stat: -1,
        subStat: -1,
        whoUpload: "",
      },
      passportInputForm: {
        id: "",
        documentPID: "",
        name: "",
        surname: "",
        passportNR: "",
        dateOfIssue: "",
        dateOfExpiry: "",
        countryOfIssue: "",
        placeOfIssue: "",
        stat: -1,
        whoUpload: "",
      },
      visaInputForm: {
        id: "",
        passportNR: "",
        country: "",
        dateOfIssue: "",
        dateOfExpiry: "",
        placeOfIssue: "",
        visaNR: "",
        stat: -1,
        subStat: -1,
        whoUpload: "",
      },
      licenseInformationInputForm: {
        id: "",
        licenseType: "",
        licenseNumber: "",
        authority: "",
        issueCountry: "",
        licenseExpiry: "",
        examinerLicenseNR: "",
        examinerLicenseEmpiry: "",
        RATING_CERTIFICATE: "",
        LICENCE_TITLE: "",
        LANGUAGE_1: "",
        LANGUAGE_1_LEVEL: "",
        LANGUAGE_1_DATE: "",
        LANGUAGE_2: "",
        LANGUAGE_2_LEVEL: "",
        LANGUAGE_2_DAT: "",
        stat: -1,
        whoUpload: "",
      },
      landingInformationInputForm: {
        expriyDate: "",
        stat: -1,
        whoUpload: "",
      },

      statColorList: [
        {
          value: -1,
          color: "white",
        },
        {
          value: 1,
          color: "#8cc3a9",
        },
        {
          value: 2,
          color: "#ffe083",
        },
        {
          value: 3,
          color: "#ed9aa2",
        },
        {
          value: 4,
          color: "#909294",
        },
      ],
    };
  },

  methods: {
    ...mapActions[("getAllAndGetByMail", "passportAll", "passportPDF")],
    async getPassports(userId) {
      try {
        let res = await this.$store.dispatch(
          "HRPersonelRequest/passportsAll",
          userId
        );
        this.personelList = JSON.parse(this.API_ResultContainerControl(res));
        res = "";
      } catch (e) {
        this.$notify({
          title: "Error",
          text: e.message,
          type: "error",
          duration: "15000",
        });
      }
    },

    TR2EN(list) {
      let newArr = [];
      newArr = JSON.parse(
        JSON.stringify(list)
          .replaceAll("İ", "I")
          .replaceAll("Ö", "O")
          .replaceAll("Ü", "U")
          .replaceAll("Ş", "S")
          .replaceAll("Ç", "C")
          .replaceAll("Ğ", "G")
      );
      return newArr;
    },

    toggle(user) {
      try {
        this.permissionID = user.ID;
        this.permFullName = user.FULLNAME;
        this.userPermsList = user.PERMS;
        const idx = this.opened.indexOf(user.ID);
        if (idx > -1) {
          this.opened.splice(idx, 1);
        } else {
          this.opened.push(user.ID);
        }
      } catch (e) {
        this.$notify({
          title: "Error",
          text: e.message,
          type: "error",
          duration: "15000",
        });
      }
    },
    exportTableToExcel() {
      try {
        const filteredEmployeeData = this.filteredData.map(
          ({
            NefaEmployeeId: employeeId,
            Workplace: company,
            FirstName: name,
            LastName: surname,
            Gender: gender,
            TLC: tlc,
            Email: email,
            DocumentNumber: passportNo,
            DateOfIssue: dateOfIssue,
            CountryOfIssue: countryOfIssue,
            NationalityCode: nationality,
            DateOfExpiry: dateOfExpiry,
            STAT: stat,
          }) => ({
            employeeId,
            company,
            name,
            surname,
            gender,
            tlc,
            email,
            passportNo,
            dateOfIssue,
            countryOfIssue,
            nationality,
            dateOfExpiry,
            stat,
          })
        );

        const header = [
          "Employee ID",
          "Company Name",
          "Name",
          "Surname",
          "Gender",
          "TLC",
          "Email",
          "Passport Number",
          "Date of Issue",
          "Country of Issue",
          "Nationality",
          "Date of Expiry",
          "STAT",
        ];

        const ws = XLSX.utils.json_to_sheet(filteredEmployeeData, header);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Result");
        XLSX.writeFile(wb, "Result.xlsx");
      } catch (exception) {
        console.log(exception);
      }
    },
    determineColorByStat(stat) {
      const daysMatch = stat.match(/(\d+)/);
      const days = daysMatch ? parseInt(daysMatch[1]) : null;

      if (stat.includes("No Expiry Date")) {
        return "#d3d3d3";
      } else if (stat.includes("days remaining")) {
        if (days >= 365) {
          return "#8cc3a9";
        } else if (days >= 180) {
          return "#ffe083";
        } else if (days >= 30) {
          return "#ed9aa2";
        } else {
          return "#ff4d4d";
        }
      } else if (stat.includes("days expired")) {
        return "#454545";
      }
      return "#ffffff";
    },

    closeModal() {
      this.globalImgUrl = "";
      this.globalPdfUrl = "";
    },

    icon(opened) {
      if (!opened) {
        return this.iconList.find((x) => x.type === true).icon;
      } else {
        return this.iconList.find((x) => x.type === false).icon;
      }
    },

    statusColor(colorIndex) {
      if (colorIndex !== undefined) {
        return this.statColorList.find((x) => x.value === colorIndex).color;
      } else {
        return;
      }
    },
    getReport() { },
    showImgBtn(row) {
      this.fileExtension = row.DocumentExtension;
      if (row.DocumentExtension.length) {
        if (row.DocumentExtension == "pdf") {
          this.getFullPdfUrl(row);
        } else {
          this.getFullImgUrl(row);
        }
      }
    },

    getFullImgUrl(row) {
      const url =
        //this.getImageUrl +
        "https://crewboxapi.corendonairlines.com/HR/personel/ShowImageVer2" +
        "/" +
        row.ID +
        "/" +
        "1" +
        "/" +
        row.DocumentPID +
        "/" +
        row.DocumentExtension +
        "/" +
        row.Workplace +
        "/" +
        row.NefaEmployeeId +
        "/" +
        row.DocumentIndexNo;


      this.globalImgUrl = url;
    },
    getFullPdfUrl(row) {
      const url =
        // this.getPdfUrl +
        "https://crewboxapi.corendonairlines.com/HR/personel/ShowPdfVer2" +
        "/" +
        row.ID +
        "/" +
        "1" +
        "/" +
        row.DocumentPID +
        "/" +
        row.DocumentExtension +
        "/" +
        row.Workplace +
        "/" +
        row.NefaEmployeeId +
        "/" +
        row.DocumentIndexNo;


      this.globalPdfUrl = url;
    },

    exportTableToPDF() {
      //filtrelemeden gelen parametreler eklenecek
      console.log(this)
      const request= {...this.user,search: this.search,searchTlc:this.searchTLC}
      this.$store.dispatch("HRPersonelRequest/passportsPDF", request,this.search, this.searchTLC);
    },
  },

  async created() {
    this.user = await JSON.parse(localStorage.getItem("user"));
    await this.getPassports(this.user);
  },

  mounted() { },
  computed: {
    filteredData() {
      let filteredData = JSON.parse(
        JSON.stringify(this.TR2EN(this.personelList))
      );
      let text = "";
      if (this.search) {
        text = this.search
          .toUpperCase()
          .replace("İ", "I")
          .replace("Ö", "O")
          .replace("Ü", "U")
          .replace("Ş", "S")
          .replace("Ç", "C")
          .replace("Ğ", "G");
        filteredData = filteredData.filter((row) => {
          return Object.values(row).some((value) => {
            return String(value).toUpperCase().includes(text.toUpperCase());
          });
        });
      } else if (this.searchTLC) {
        let tlcText = this.searchTLC
          .toUpperCase()
          .replace("İ", "I")
          .replace("Ö", "O")
          .replace("Ü", "U")
          .replace("Ş", "S")
          .replace("Ç", "C")
          .replace("Ğ", "G");

        filteredData = filteredData.filter((row) => {
          return String(row.TLC).toUpperCase().includes(tlcText.toUpperCase());
        });
      }

      return filteredData;
    },
  },
};
</script>
